import axios from "axios";
import { useState } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import LoadingTrophy from "./../../Loading/LoadingTrophy";
import digitConverter from "./../../utils/digitConverter";
import thConverter from "./../../utils/thConverter";
import WebinarLBRow from "./WebinarLBRow";

const WebinarLeaderboard = () => {
  const [myPosition, setMyPosition] = useState(0);

  const params = useParams();
  const level = params.level;
  const batch = params.batch;

  const getStudentList = async () => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_API}/webinar/leaderboard/get/${params.batch}/${level}`
    );

    return data;
  };

  const sn = params.sn;
  const queryName = "webinar_leaderBoard" + level;
  const {
    isLoading,
    isFetching,
    data: students,
    refetch,
  } = useQuery(queryName, getStudentList);

  if (isLoading) {
    return <LoadingTrophy />;
  }

  const myResult = (students?.result).find(
    (student) => student.sn == params.sn
  );

  const th = (m) => {
    if (m == 1) return "st";
    if (m == 2) return "nd";
    if (m == 3) return "rd";
    return "th";
  };

  // dynamic merit position
  let p = 500;
  let i = -1;
  const getPosition = (score) => {
    if (!score) return;

    if (score < p) {
      p = score;
      i = i + 1;
    }
    return i;
  };

  return (
    <div>
      <div className="text-center my-10 text-xl">
        <p>Welcome to Leaderboard </p>
        <p>Webinar {params.batch}</p>
      </div>

      <div>
        <div className="overflow-x-auto w-10/12 mx-auto mb-20">
          <table className="table w-full">
            <thead>
              <tr>
                <th className="bg-green-200">Merit</th>
                <th>SN</th>
                <th>Name</th>
                <th>Exm_1</th>

                <th className="bg-red-200">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr className="">
                <th className="bg-yellow-100 font-bold">
                  {digitConverter(myPosition)}{" "}
                  <sup>{thConverter(myPosition)}</sup>
                </th>
                <th className="bg-yellow-100">{myResult?.sn}</th>
                <td className="bg-yellow-100">
                  {myResult?.name.toUpperCase()}
                </td>

                {level === "1" && (
                  <>
                    <th className="bg-yellow-100">
                      {myResult?.webinar1data[0]?.Score}
                    </th>

                    <th className="bg-yellow-100 text-red-600">
                      {myResult?.webinar1Total}
                    </th>
                  </>
                )}
              </tr>
              <tr>
                <td></td>
              </tr>

              {students?.result?.map((student, index) => (
                <WebinarLBRow
                  key={index}
                  merit={getPosition(student.webinar1Total)}
                  student={student}
                  setMyPosition={setMyPosition}
                  level={level}
                  mySn={myResult?.sn}
                ></WebinarLBRow>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default WebinarLeaderboard;
